import { CloudOff, TriangleAlert } from "lucide-react";
import { useEffect, useState } from "react";
import { useOfflineQueue } from "@/shared/offline/offlineQueue";

export function OfflineSyncBadge() {
  const hasSyncFailure = useOfflineQueue((state) => state.queue.some((mutation) => Boolean(mutation.lastError)));
  const hydrate = useOfflineQueue((state) => state.hydrate);
  const [online, setOnline] = useState(navigator.onLine);

  useEffect(() => {
    void hydrate();

    const setOnlineStatus = () => setOnline(navigator.onLine);
    window.addEventListener("online", setOnlineStatus);
    window.addEventListener("offline", setOnlineStatus);

    return () => {
      window.removeEventListener("online", setOnlineStatus);
      window.removeEventListener("offline", setOnlineStatus);
    };
  }, [hydrate]);

  if (!online) {
    return (
      <span className="inline-flex max-w-[122px] items-center gap-1.5 rounded-full bg-danger/10 px-2 py-1 text-[10px] font-semibold text-danger sm:max-w-none sm:gap-2 sm:px-3 sm:text-xs" title="Offline — changes saved locally">
        <CloudOff size={14} aria-hidden />
        <span className="truncate sm:hidden">Offline</span>
        <span className="hidden truncate sm:inline">Offline — changes saved locally</span>
      </span>
    );
  }

  if (hasSyncFailure) {
    return (
      <span className="inline-flex max-w-[122px] items-center gap-1.5 rounded-full bg-danger/10 px-2 py-1 text-[10px] font-semibold text-danger sm:max-w-none sm:gap-2 sm:px-3 sm:text-xs" title="A background sync failed — changes are saved locally">
        <TriangleAlert size={14} aria-hidden />
        <span className="truncate sm:hidden">Sync issue</span>
        <span className="hidden truncate sm:inline">Sync failed — changes saved locally</span>
      </span>
    );
  }

  return null;
}
